<!-- 关联工单 -->
<template>
  <div :class="['item-list', currentTargetOrderId === prop.info.workOrderId ? 'isCurrent' : '']">
    <div class="z-flex">
      <div class="z-flex order-id">
        <span @click="viewDetails" class="id">ID：{{ info.workOrderId }}</span>
        <auth-img class="copy" :src="copy" @click="handleCopy(info.workOrderId)" />
      </div>
      <div>{{ info.createAt && formatTime(moment(info.createAt).valueOf()) }}</div>
    </div>
    <div
      class="z-flex item-title"
      :style="{ cursor: prop.currentFlag ? 'pointer' : '' }"
      @click="handleClickCurrentOrder"
    >
      <div class="title">
        {{ info.workBusinessTypeDesc }}
        <!-- 如果有备注信息并且支持编辑就隐藏-没有则不隐藏 -->
        <div class="remarks" v-if="prop.remarkIsEdit && !info.remark" @click.stop="handleRemarks">
          <auth-img class="remarksIcon" :src="edit" />
          备注
        </div>
      </div>
    </div>
    <div class="item-title timerRoll">
      <div class="timerBox">
        <div v-if="timeRollBack?.countdown">
          <div class="rollbackTimer" v-if="timeRollBack?.countdown > rollBackSplit">
            {{ timeRollBack?.formatTime || '--' }}
          </div>
          <div class="closeToRollBack" v-else>
            <span class="close">回滚</span>
            <span class="timer">{{ timeRollBack?.formatTime || '--' }}</span>
          </div>
        </div>
      </div>
      <div>
        <span class="order-flag" v-if="info.businessType === 38 && info?.feedbackNumber > 1">
          {{ `第${info?.feedbackNumber}次反馈` }}
        </span>
        <span class="order-flag" v-if="info.suspendTag">
          {{ ['', '已挂起', '自动挂起'][info.suspendTag] || '-' }}
        </span>
        <span class="order-flag" v-if="info.allocatedNum > 1">分配+{{ info.allocatedNum }}</span>
      </div>
    </div>
    <div :class="['msg', currentTargetOrderId === prop.info.workOrderId ? 'isCurrentMsg' : '']">
      <!-- 临观标签 -->
      <auth-img
        src="@/assets/img/work-place/lin-guan.png"
        alt="临观标签"
        v-if="info.activityFlag"
      />
      <span class="guideInquiry" v-if="info.businessType === 10">导诊</span>
      <div
        v-html="brightenKeyword(info)"
        class="workdec"
        @click="handleDetail"
        :class="{ pointer: info.serialNumber || info.reserveSn }"
      ></div>
    </div>

    <!-- 备注展示 -->
    <div v-if="info.remark" class="remarksContent" @click="handleRemarks">
      <a-tooltip>
        <template #title>
          {{ info.remark }}
        </template>
        <div class="z-flex">
          <div class="left">备注</div>
          <div class="content">
            {{ info.remark }}
          </div>
          <auth-img :src="iconSrc" v-if="prop.remarkIsEdit" class="rightIcon" alt="" />
        </div>
      </a-tooltip>
    </div>
    <!-- 复诊提醒有其他处理中的工单会话 -->
    <div v-if="prop.info.businessType == 33 && prop.currentFlag">
      <ReSubWorkOrder
        :isCurrent="currentTargetOrderId === prop.info.workOrderId"
        :info="info"
        @getTaskReserveList="getTaskReserveList"
      />
    </div>

    <div class="item-operate z-flex">
      <div>
        <div class="status">
          <div
            class="img"
            :style="{ backgroundImage: `url(${orderStatusbars[activeKey].src})` }"
          ></div>
          <div class="text" :style="{ color: orderStatusbars[activeKey].color }">
            {{ orderStatusbars[activeKey].text }}
            <!-- {{ info.stateTag === 1 || info.stateTag === 3 ? `—` + '自动完成' : '' }} -->
            <span v-if="[1, 3].includes(info.stateTag)">—自动完成</span>
            <span v-else-if="[6, 7].includes(info.stateTag)">-已失效</span>
            <span v-else></span>
          </div>
        </div>
        <div class="tips" v-if="prop.info.businessType === 33">{{ getNumber() }}</div>
      </div>

      <div class="btn-list z-flex" v-if="currentFlag">
        <template v-if="activeKey === 'processing' && info.suspendTag !== 2">
          <a-button class="btn" @click="beforeHungup">
            {{ info.suspendTag === 0 ? '挂起' : '取消挂起' }}
          </a-button>
        </template>
        <div v-for="item in orderStatusbars[activeKey].btns" :key="item.key">
          <a-button
            :type="item.type"
            @click="item.cb"
            v-if="item.showFormat()"
            class="btn"
            :disabled="buttonDisabled(item)"
          >
            {{ item.key }}
          </a-button>
        </div>
      </div>
      <div v-else class="btn-list">
        {{ orderStatusbars[activeKey].other.label }}
        {{ handlerName(info) }}
      </div>
    </div>
  </div>
  <the-detail
    v-model:visible="detail.detailVisible"
    :serialNumber="detail.serialNumber"
    :recordType="detail.recordType"
    :id="detail.id"
  />
  <ADetail ref="aDetail" :reserveSn="appointId" />
  <DetermineEffect ref="determineRef" @completeBuss="() => finishConfirm()" />
  <FullCourseConfirm
    ref="fullcourseRef"
    :doctorInfo="doctorInfo"
    @completeBuss="() => finishConfirm()"
  />
  <EffectFeedBack
    ref="effectFeedBackRef"
    :info="info"
    :curGroupInfo="curGroupInfo"
    @completeBuss="() => finishConfirm()"
  />
  <NoRetreatReasonCollect
    ref="reasonCollectRef"
    :info="info"
    @completeBuss="() => finishConfirm()"
  />

  <GuideResultConfirm
    ref="guideResultRef"
    :info="info"
    :curGroupInfo="curGroupInfo"
    @supplayMedicalRecord="toMedicalRecord"
    @completeBuss="() => finishConfirm()"
  />
  <FollowupConfirm ref="followupRef"></FollowupConfirm>
  <PatientInfoDetails
    :showAllDialog="showAllDialog"
    :currentInfo="currentInfo"
    @handleCancel="handleCancel"
  />
  <OrderRemark ref="orderRemarKRef" />

  <!-- 诊疗记录弹窗部分 -->
  <medicalRecordsPoup
    :visible="supplementMRecord.uploadRecordVisible"
    :params="supplementMRecord.query"
    @cancelClick="supplementMRecord.onClose"
    :id="supplementMRecord.uploadRecordId"
    @savaData="supplementMRecord.refreshOffLineRecord"
  ></medicalRecordsPoup>
  <!--完成咨询工单弹窗-->
  <ConsultationCompleted ref="consultationCompletedRef" @saveSuccess="saveSuccess" />
  <!-- 填写未购原因弹窗 -->
  <ModalNotPurchased
    :workOrderId="prop.info.workOrderId"
    @handleOk="finishConfirm"
    ref="ModalNotPurchasedDOM"
  ></ModalNotPurchased>
</template>
<script setup>
import { finishChat, getFinishPrecheck, getPrescriptionPurchaseByWorkOrderId } from '@/api/chat'
import { ref, computed, defineEmits, defineProps, reactive, nextTick, createVNode } from 'vue'
import { formatTime, handleCopy } from '@/utils'
import moment from 'moment'
import processing from '@/assets/img/chat/processing.png'
import pending from '@/assets/img/chat/pending.png'
import copy from '@/assets/img/work-place/copy.png'
import edit from '@/assets/img/edit.png'
import TheDetail from '@/components/TheDetail/index.vue'
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
import { subStringToType, brightenKeyword } from '@/utils/index'
import DetermineEffect from '@/components/DetermineEffect'
import FullCourseConfirm from '@/components/eventConfirm/fullCourseConfirm.vue'
import EffectFeedBack from '@/components/eventConfirm/effectFeedBack.vue'
import GuideResultConfirm from '@/components/eventConfirm/guideResultConfirm.vue'
import FollowupConfirm from '@/components/eventConfirm/followupConfirm.vue'
import NoRetreatReasonCollect from '@/components/eventConfirm/noRetreatReasonCollect.vue'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import ReSubWorkOrder from './reSubWorkOrder/index.vue'
const iconSrc = require('@/assets/img/work-place/right.png')
import { Modal, message } from 'ant-design-vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import useHungup from '../hooks/useHungup'
import OrderRemark from './orderRemark.vue'
import { REFRESH_MAIN, REFRESH_LIST } from '@/views/WorkPlace/handleEventBuss'
import { FINISH_ORDER } from '@/views/WorkPlace/handleEventBuss'
import medicalRecordsPoup from '@/views/HealthRecord/HealthInfo/common/medicalRecordsPoup.vue'
import ConsultationCompleted from './ConsultationCompleted/index.vue'
import Config from '@/config/index'
import { useReadStatus } from '../../../hooks'
import ModalNotPurchased from './ModalNotPurchased/index.vue'

const { handleHungup } = useHungup()
const { finishPrecheck } = useReadStatus()
const emit = defineEmits(['openTransfer'])
const store = useStore()
const curGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
const orderRemarKRef = ref(null)

const prop = defineProps({
  // 备注是否可以编辑
  remarkIsEdit: {
    type: Boolean,
    default: false
  },
  doctorInfo: {
    type: Object,
    default: () => {},
    require: true
  },
  info: {
    type: Object,
    default: () => {},
    require: true
  },
  currentFlag: {
    // 区分当前工单和其他工单
    type: Boolean,
    default: true
  }
})

// 回滚时间
const timerCollection = computed(() => store.state.rollBack.roundInstance)
const timeRollBack = computed(() => timerCollection.value.get(Number(prop.info.workOrderId)))
const rollBackSplit = computed(() => store.state.rollBack.rollBackSplit)

const consultationCompletedRef = ref(null)
const list = ref([])
const determineRef = ref(null)
const detail = reactive({
  detailVisible: false,
  serialNumber: '',
  recordType: '',
  id: ''
})
// 复诊预约
const aDetail = ref(null)
const appointId = ref('')
//工单状态字典 workOrderStatus： 1 待分配，100 待处理， 101 处理中，200 已完成 300 已过期 400 已失效
// 关联工单只展示待处理和处理中的工单
const activeKey = computed(() => (prop.info.workOrderStatus === 100 ? 'pending' : 'processing'))

const currentTargetOrderId = computed(
  () => store.state.workOrder.workOrderGroupInfo.targetWorkOrder.workOrderId
)
const getNumber = () => {
  const waitList = list.value.filter(item => item.taskStatus === 0)
  return `待完成 ${waitList.length || 0} 人`
}
const getTaskReserveList = DataList => {
  list.value = DataList
}
const buttonDisabled = item => {
  if (item.key === '转交') {
    return (
      prop.info.workOrderStatus === 101 && (prop.info.stateTag === 1 || prop.info.stateTag === 3)
    )
  } else if (item.key === '完成') {
    // 处理复诊提醒的转交状态
    if (prop.info.businessType == 33 && prop.currentFlag) {
      return list.value.length > 0 ? list.value.some(item => !item.taskStatus) : true
    }
  }
  return false
}
const handleRemarks = () => {
  // 如果支持编辑就显示编辑弹窗
  if (!prop.remarkIsEdit) return
  const param = {
    info: prop.info
  }
  orderRemarKRef.value.initModal(param)
}

const handleClickCurrentOrder = () => {
  if (currentTargetOrderId.value === prop.info.workOrderId || !prop.currentFlag) return
  Modal.confirm({
    centered: true,
    title: '切换工单',
    icon: createVNode(ExclamationCircleOutlined),
    content: `确定要切换工单吗？`,
    okText: '确定',
    cancelText: '取消',
    onOk: () => {
      store.commit('workOrder/SET_TARGET_WORK_ORDER', prop.info.workOrderId)
    }
  })
}

// 工单状态处理
const orderStatusbars = reactive({
  pending: {
    text: '待处理',
    other: {
      // 分配其他账号-待处理
      label: '处理人：',
      key: 'handler'
    },
    color: '#FFA940',
    src: pending
  },
  processing: {
    text: '处理中',
    // 处理中：转交和完成
    btns: [
      {
        key: '转交',
        cb: openTransfer,
        type: 'default',
        showFormat: () => {
          // 仅限制原有导诊、需求跟踪和处方待购类型，疗效工单沿用现有转交流程
          return !Config.INSTANT_ORDER_TYPE.includes(prop.info.businessType)
        }
      },
      {
        key: '完成',
        cb: finishConfirm,
        type: 'primary',
        showFormat: () => {
          return true
        }
      }
    ],
    other: {
      // 分配其他账号-待处理
      label: '处理人：',
      key: 'handler'
    },
    color: '#1890FF',
    src: processing
  }
})

//handlerType(1001：BD,1002：健管)
const handlerTypeText = {
  1001: 'BD',
  1002: '健管'
}
const handlerName = info => {
  const { handler, handlerType } = info
  if (!handler) return '--'
  return handlerTypeText[handlerType] + '—' + handler
}
const handleFinish = () => {
  return new Promise((resolve, reject) => {
    finishChat({
      workOrderId: prop.info.workOrderId,
      ucDoctorId: prop.doctorInfo.ucUserId,
      compatibleHandleFlag: true,
      completeState: 1
    }).then(res => {
      const { tipMessage, tipFlag } = res || {}
      if (tipMessage) {
        Modal.confirm({
          title: '工单未处理提示',
          icon: createVNode(ExclamationCircleOutlined),
          content: tipMessage,
          okText: '知道了',
          centered: true,
          onOk: () => {
            reject()
          }
        })
      } else if (!tipFlag) {
        resolve()
      } else {
        reject(tipFlag)
      }
    })
  })
}

const fullcourseRef = ref(null)
const reasonCollectRef = ref(null)
const effectFeedBackRef = ref(null)
const guideResultRef = ref(null)
const followupRef = ref(null)

// 咨询完成
const saveSuccess = () => {
  finishConfirm()
}
const ModalNotPurchasedDOM = ref()
// 判断是否有未购买, 并且未填写过
const hasPurchased = async () => {
  const params = {
    workOrderId: prop.info.workOrderId
  }
  const status = await getPrescriptionPurchaseByWorkOrderId(params)
  if (status === false) {
    ModalNotPurchasedDOM.value.init()
  }
  return status
}

async function finishConfirm() {
  const has = await hasPurchased()
  if (has === false) return
  // // 判断群组消息是否已读
  const params = {
    workOrderId: currentTargetOrderId.value,
    type: 0
  }
  const isRead = await finishPrecheck(params)
  if (!isRead) return
  handleFinish()
    .then(() => {
      message.success('工单完成！')
      store.dispatch('rollBack/getAllRefreshTimer')
      FINISH_ORDER?.emit()
    })
    .catch(res => {
      if (!res) {
        FINISH_ORDER?.emit()
        return
      }
      //电话咨询完成弹窗
      if (res === 9) {
        consultationCompletedRef.value.initData(prop.info.workOrderId)
        return
      }
      // 待加入全病程弹窗
      if (res === 4) {
        fullcourseRef.value.confirmVisible = true
        return
      }
      // 未复诊原因收集
      if (res === 5) {
        reasonCollectRef.value.initModal()
        return
      }

      // 疗效反馈弹窗
      if (res === 6) {
        effectFeedBackRef.value.initModal()
        return
      }

      // 导诊咨询工单
      if (res === 7) {
        guideResultRef.value.initModal()
        return
      }

      // 随访任务工单
      if (res === 8) {
        followupRef.value.initModal()
        return
      }

      // 若有返回值默认打开
      const {
        follUpPlanFlowId: followUpPlanFlowId,
        serialNumber,
        follUpPlanId: followupPlanId
      } = prop.info
      // 1:弹处方判断 2：弹疗效跟踪  3：弹处方判断+疗效跟踪
      const params = {
        mode: res,
        visitInfo: {
          followUpPlanFlowId
        },
        prescriptInfo: {
          operationType: 0, //0-判定 1-修改判定
          operationSource: 2, //0 是修改，1是处方详情里面判断 ，2是工单里面判断
          serialNumber,
          originalSource: 5,
          followupPlanId
        }
      }
      determineRef.value.initModal(params)
    })
}
function openTransfer() {
  emit('openTransfer', prop.info.workOrderId)
}

// 去补充诊疗记录
const toMedicalRecord = () => {
  supplementMRecord.uploadRecordVisible = true
}

//补充诊疗记录
const { patientInfo, doctorInfo } = curGroupInfo.value
const supplementMRecord = reactive({
  uploadRecordId: null,
  uploadRecordVisible: false,
  query: {
    ucPatientId: patientInfo.ucUserId,
    ucDoctorId: doctorInfo.ucUserId,
    reserveEntry: 3,
    needWorkOrderId: true,
    workOrderId: currentTargetOrderId.value
  },
  onClose: () => {
    supplementMRecord.uploadRecordVisible = false
  },
  refreshOffLineRecord: async (type, args) => {
    supplementMRecord.uploadRecordVisible = false
    const { reserveDate, reserveDateDetail, revisitType } = args
    // 选择了遵医嘱复诊
    guideResultRef.value.showTips = false
    if (reserveDate && reserveDateDetail && revisitType) {
      guideResultRef.value.closeModal()
      finishConfirm()
    }
  }
})

// 查看处方单、预约单详情以及随访详情
const handleDetail = () => {
  const { serialNumber, businessType, reserveSn, follUpPlanId } = prop.info
  if (businessType === 7) {
    if (!reserveSn) return
    appointId.value = reserveSn
    nextTick(() => {
      aDetail.value.mVisible = true
      aDetail.value.initDetail()
    })
  } else if (businessType === 11 || businessType === 12) {
    if (!follUpPlanId) return
    detail.detailVisible = true
    detail.id = follUpPlanId
    detail.recordType = 'visit'
  } else {
    if (!serialNumber) return
    detail.serialNumber = serialNumber
    detail.recordType = subStringToType(serialNumber)
    detail.detailVisible = true
  }
}
// 查看工单详情
const showAllDialog = ref(false)
const currentInfo = ref({})
const viewDetails = () => {
  showAllDialog.value = true
  const { workOrderId, businessType } = prop.info
  const { patientInfo, assistantPatientGroupId, groupId, doctorDaGroupId } = curGroupInfo.value
  const params = {
    ucPatientId: patientInfo.ucUserId,
    ucPatientName: patientInfo.username,
    workOrderId,
    businessType,
    doctorPatientGroupId: groupId,
    assistantPatientGroupId,
    assistantDoctorGroupId: doctorDaGroupId
  }
  currentInfo.value = params
}
const handleCancel = () => {
  showAllDialog.value = false
  currentInfo.value = {}
}
// 工单挂起
const beforeHungup = () => {
  const { suspendTag, workOrderId } = prop.info
  const params = {
    workOrderIds: [workOrderId],
    suspendTag: suspendTag ? 0 : 1,
    batchFlag: false,
    callBack: () => {
      REFRESH_MAIN?.emit()
      REFRESH_LIST?.emit()
      store.dispatch('rollBack/getAllRefreshTimer')
    }
  }
  handleHungup(params)
}
</script>
<style scoped lang="scss">
.tips {
  margin-top: 3px;
  font-size: 12px;
  color: #f5222d;
  letter-spacing: 0;
}
.remarksContent {
  position: relative;
  font-size: 12px;
  color: #666666;
  margin-top: 12px;
  cursor: pointer;
  align-items: top;

  .left {
    width: 34px;
  }
  .content {
    width: 275px;
    color: #f78408;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    -webkit-box-orient: vertical;
  }
  .rightIcon {
    position: relative;
    right: 0;
    width: 14px;
    height: 14px;
  }
}
.item-list {
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  padding: 8px 10px 12px;
  border: 1px solid #e8e8e8;
  margin-bottom: 8px;
  border-radius: 5px;
  position: relative;
  padding-bottom: 60px;
  .order-id {
    .id {
      cursor: pointer;
      text-decoration-line: underline;
      color: #1e7bff;
    }
    align-items: center;
    line-height: initial;
  }
  .copy {
    width: 10px;
    height: 10px;
    cursor: pointer;
    margin-left: 4px;
  }
  .item-title {
    font-weight: 500;
    font-size: 14px;
    color: #303133;
    margin: 8px 0;
    .title {
      display: flex;
      .remarks {
        margin-left: 10px;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        .remarksIcon {
          width: 14px;
          height: 14px;
        }
      }
    }

    .order-flag {
      padding: 1px 4px;
      border-radius: 2px;
      font-weight: 400;
      font-size: 10px;
      margin-left: 8px;
      border: 1px solid #ffa940;
      color: #ffa940;
    }
  }

  .timerRoll {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .timerBox {
      // flex: 1;
      flex-shrink: 0;
      width: fit-content;
    }
    .rollbackTimer {
      max-height: 16px;
      font-size: 10px;
      padding: 3px 5px;
      background: #e5faef;
      border-radius: 2px;
      color: #60d195;
      display: flex;
      align-items: center;
    }
    .closeToRollBack {
      max-height: 16px;
      font-size: 10px;
      display: flex;
      align-items: center;
      background-color: #fef2f0;
      border-radius: 2px;

      .close {
        width: 27px;
        height: 16px;
        background: #ff4848;
        border-radius: 2px 0 0 2px;
        text-align: center;
        color: #fff;
        margin-right: 5px;
      }
      .timer {
        display: inline-block;
        color: #ff4848;
        background-color: #fef2f0;
        padding-right: 5px;
        border-radius: 2px;
        min-width: 29px;
        text-align: center;
      }
    }
  }

  .msg {
    .guideInquiry {
      padding: 2px 4px;
      font-weight: 400;
      font-size: 10px;
      color: #464646;
      background: #e2e2e2;
      border-radius: 2px;
      margin-right: 2px;
    }
    img {
      margin-right: 4px;
    }
    .workdec {
      overflow-wrap: break-word;
      display: inline;
      &.pointer {
        cursor: pointer;
      }
    }
    padding: 8px;
    background: rgba(216, 216, 216, 0.24);
    border-radius: 4px;
    font-size: 14px;
    max-height: 100px;
    overflow-y: auto;
    color: #666666;
  }
  .isCurrentMsg {
    background: #e8ecf2;
    color: #666666;
    font-weight: bold;
  }

  .item-operate {
    margin-top: 12px;
    align-items: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    // padding: 8px 11px;
    height: 52px;
    padding: 0 11px;
    box-shadow: 0 -2px 5px rgba(51, 51, 51, 0.05);
    .status {
      display: flex;
      align-items: center;
      .img {
        min-width: 14px;
        min-height: 14px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        img {
          width: 100%;
        }
      }
      .text {
        margin-left: 4px;
        line-height: initial;
        font-size: 12px;
        font-weight: bold;
      }
    }
    .btn-list {
      .btn {
        margin-left: 7px;
        width: 64px;
        height: 28px;
        padding: 0;
        border-radius: 2px;
        overflow: hidden;
      }
      .btn::before {
        content: '';
        margin-left: 2px;
      }
    }
  }
}

.isCurrent {
  position: relative;
  border: 1px solid #1890ff;
  border-radius: 5px;
  background-color: #f6fbff;
  overflow: hidden;
  padding-bottom: 60px;
}
</style>
